import { render, staticRenderFns } from "./SubProductUpdateViewModal.vue?vue&type=template&id=349bf6ae&"
import script from "./SubProductUpdateViewModal.vue?vue&type=script&lang=js&"
export * from "./SubProductUpdateViewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports